



















































































import gql from "graphql-tag";
import wx from 'weixin-js-sdk'; // H5<->微信小程序通信SDK

export default {
  name: '',
  data() {
    return {
      taskId: -1, // 随访任务ID
      patientInfo:{
        id: "",
        name:"",
        id_in_hospital:""                  
      },
      doctorInfo:{
        id: "",
        unit: "",
        name: "",
      },

      formTemplate: {}, // 随访表单模板. .content为 JSON数据
      notificationTemplate: {}, // 随访提醒模板 .content为 JSON数据

      // 表单样式，用于预览已设计的表单
      jsonData: {
      }, 
      // 表单数据
      formValues: {}, 

      // PC端还是手机端
      IsPCPlateform: true,
      
      remoteFuncs: {
          // 组件配置时配置的远端方法,保持和配置时输入的名称一致
          func_test (resolve) {
              // 模拟接口请求
              setTimeout(() => {
                  const options = [
                      {id: '1', name: '1111'},
                      {id: '2', name: '2222'},
                      {id: '3', name: '3333'}
                  ]

                  // 获取到的值和标签可以通过配置页远端配置
                  // 值:id  标签：name
                  resolve(options) // 将后端获取的数据放入回调函数中
              }, 2000)
          },

      },
      isWeixinBrowser: false,
      isWeixinMiniProgram: false,
      wxConfig: {
        debug: false, // 开启调试模式，调用的所有API的返回值会在客户端alert出来
        appId: '', // 必填，公众号的唯一标识
        timestamp: '', // 必填，生成签名的时间戳
        nonceStr: '', // 必填，生成签名的随机串
        signature: '', // 必填，签名
        jsApiList: ['updateAppMessageShareData', 'updateTimelineShareData'] // 必填，需要使用的JS接口列表
      },
      isLoading: false,
 
    }
  },
  methods: {
    async getPatient(id){
      let res = await this.$apollo.query({
        query: gql`query($id: Int!){
                    patient(id: $id) {
                        name
                        update_time
                    }
                }`,
        variables: {
            id
        },
      });
      if(res.data.patient!==null){
        this.patientInfo.name = res.data.patient.name
      }   
    },

    async getDoctor(id){
      let res = await this.$apollo.query({
        query: gql`query($id: Int!){
                    doctor(id: $id) {
                        username
                        realname
                        unit
                    }
                }`,
        variables: {
            id
        },
      });
      if(res.data.doctor!==null){
        this.doctorInfo.name = res.data.doctor.realname
        this.doctorInfo.unit = res.data.doctor.unit
      }                            
    },


    async getTask(){
      try{
        this.isLoading = true;
 
        let response = await this.$apollo.query({
          query: gql`query($id: Int!){
                      followupTask4Guest(id: $id) 
                  }`,
          fetchPolicy: "no-cache",
          variables: {
              id: this.taskId                            
          },
        });
        console.log("In followupForm.vue, getTask, response:", response.data); 
        if(response.data.followupTask4Guest!==null){
            let followupTask = JSON.parse(response.data.followupTask4Guest);
            console.log("In followupForm.vue, getTask, followupTask:", followupTask); 
            let patient = followupTask.patient;
            let doctor = followupTask.doctor;
            this.patientInfo.name = patient.name
            this.doctorInfo.name = doctor.realname
            this.doctorInfo.unit = doctor.unit
            
            
            this.formValues = JSON.parse(followupTask.task.form_value); // 表单内容
            // this.patientInfo.id = followupTask.task.patient_id;
            // await this.getPatient(this.patientInfo.id);
            this.formTemplate = followupTask.form_template; // 随访表单模板
            this.notificationTemplate = followupTask.notification_template; // 随访提醒模板
            this.jsonData = JSON.parse(this.formTemplate.content); // 表单模板格式内容
            // let plan = followupTask.plan;
            // if(plan){                  
            //   this.doctorInfo.id = plan.doctor_id;
            //   console.log("In followupForm.vue， patient_id and doctor_id:", this.patientInfo.id, this.doctorInfo.id);
            //   await this.getDoctor(this.doctorInfo.id);                   
            // }          
        } else{
          this.$message.error("未获取到随访任务信息！");
        }
        this.isLoading = false;
 
      }catch(err){
        this.$message.error("获取随访任务信息失败！");
        this.isLoading = false;
      }
      
    },

    // 检测是否在微信浏览器中
    checkWeixinBrowser() {
      const ua = navigator.userAgent.toLowerCase();
      this.isWeixinBrowser = /micromessenger/i.test(ua);
    },
    
    // 检测是否在小程序web-view环境中
    checkWeixinMiniProgram() {
      // console.log("window.navigator.userAgent:",navigator.userAgent)
      const ua = navigator.userAgent.toLowerCase();
      const isMiniProgram = /miniprogram/i.test(ua) || /miniProgram/i.test(ua);
      // wx.miniProgram.getEnv(function(res) {
      //   console.log(res.miniprogram) // true
      // })
      if (isMiniProgram) {
        // UA检测到小程序环境
        this.isWeixinMiniProgram = true;
        console.log('当前在小程序web-view环境中（通过UA检测）');
      } else {
        this.isWeixinMiniProgram = false;
        console.log('当前不在小程序web-view环境中');
      }
    },

    // 初始化微信JS-SDK
    async initWeixinJsSdk() {
      try {
        // 通常需要从后端获取配置参数
        // 这里仅作示例，实际使用时需要从服务器获取签名等信息
        // const response = await this.$http.get('/api/wechat/jssdk-config', {
        //   params: { url: window.location.href.split('#')[0] }
        // });
        // const config = response.data;
        
        // 使用配置参数初始化微信JS-SDK
        // this.wxConfig = { ...this.wxConfig, ...config };
        
        wx.config(this.wxConfig);
        
        wx.ready(() => {
          console.log('微信JS-SDK初始化成功');
        });
        
        wx.error((err) => {
          console.error('微信JS-SDK初始化失败:', err);
        });
      } catch (error) {
        console.error('获取微信JS-SDK配置失败:', error);
      }
    },
    

    switchPlateform(val){
      console.log(val)
    },

    // 提交表单结果
    async handleSubmit () {
      this.$refs.generateForm.getData().then(data => {
        this.formValues = data
        this.$alert('确认提交问卷?').then(() => {
          console.log(this.formValues);
          this.$apollo.mutate({
            mutation: gql`mutation ($id: Int!, $scheduled_time: String, $actual_time: String, $status: String,$form_value: String, $summary: String, $is_abnormal: Int, $valid: Int, $note: String) {
              modifyFollowupTask4Guest(
                  id: $id
                  scheduled_time: $scheduled_time
                  actual_time: $actual_time
                  status: $status
                  form_value: $form_value
                  summary: $summary
                  is_abnormal: $is_abnormal
                  valid: $valid
                  note: $note
              )
            }`,
            variables: {
              id: this.taskId,
              form_value: JSON.stringify(this.formValues),
              status:'COMPLETED',
            }
          });

          this.$message.success('提交成功,请返回!')
        }).catch(() => {
          this.$message.info('取消提交')
        })
      }).catch(() => {
        this.$message.error('获取数据失败')
      })
    },
    handleRest () {
      this.formValues = {}
      this.$refs.generateForm.reset()
    },
    handleSetData () {
      this.$refs.generateForm.setData({
        input: 'new 123',
        textarea: 'new 123',
        radio: 'Option 1'
      })
    },

    parseURLParams(keyword){
      const url = window.location.href;
      const searchStr = url.split('?')[1];
      const params = searchStr.split('&');
      for(let item of params){
        let param = item.split('=');
        if(param[0] === keyword){
          console.log("parse", keyword, ', value: ', param[1]);
          return param[1]
        } 
      }
      return null
    },

    async init(){
      console.log("获取route传入路由参数：", this.$route.params);
      // 跳转而来，带参数(适用于登录后跳转，route初始化过)
      if (this.$route.params.taskId!==undefined){
        this.taskId = this.$route.params.taskId;
        console.log("传入路由参数，任务ID：", this.taskId);
        this.getTask();                  
      }else if(this.parseURLParams('taskId')){
        // 适用于小程序直接打开网页URL
        this.taskId = this.parseURLParams('taskId');
        console.log("传入URL参数，任务ID：", this.taskId);
        this.getTask();  
      }else {
        // 不带参数，错误
        console.log("未获取路由参数或URL参数，错误！");
      }                
    },

  },
  mounted() {
    console.log("In followupForm, mounted, haslogin:",this.$store.state.hasLogin);
    
    // 检测是否在小程序web-view环境中
    this.checkWeixinMiniProgram();
    
    // 如果在微信环境中，初始化微信JS-SDK
    // if (this.isWeixinMiniProgram) {
    //   // this.initWeixinJsSdk();
    //   console.log("在微信小程序中");
    // } else{
    //   console.log("不在微信小程序中");
    // }

    this.init();
  }
};
